import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=a6667c28&"
import script from "./viewForm.vue?vue&type=script&lang=js&"
export * from "./viewForm.vue?vue&type=script&lang=js&"
import style0 from "./viewForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "viewForm.vue"
export default component.exports